import { logger } from '@urc-ui/services/logger';

/**
 * Adds entityId to url query params if not already available in query params
 */
export const addQueryParams = () => {
  const entityId = window.AppContext?.entityId;
  if (!entityId) {
    logger.logFatalMessage('entityId is not available on AppContext');
    return;
  }

  let shouldUpdateQueryParams = false;
  const url = new URL(window.location.href);
  if (!url.searchParams.get('entityId')) {
    url.searchParams.set('entityId', window.AppContext.entityId as string);
    shouldUpdateQueryParams = true;
  }

  if (shouldUpdateQueryParams) window.history.pushState({}, '', url);
};

export const isSpoofer = () => {
  return window.AppContext?.isSpoofer === 'true';
};

export const canSpooferDownloadReport = () => {
  const value = window.AppContext?.canSpooferDownloadReport;
  return value === undefined || value === 'true';
};

export const isFlexibleReportsRoute = () => {
  return window.location.pathname.includes('/reporting');
};

export const isADSPReportCenterEnabled = () => {
  return window.AppContext?.isADSPReportCenterR1Enabled === 'true';
};

export const isFlexibleReportsM2P1Enabled = () => {
  return window.AppContext?.isFlexibleReportsM2P1Enabled === 'true';
};

export const DEFAULT_LOCALE = 'en_US';
/**
 * Returns locale codes separated by an underscore
 * @returns {string}
 * @example 'en_US'
 * @example 'fr_FR'
 */
export const getLocale = () => {
  if (!window.AppContext?.locale) {
    return DEFAULT_LOCALE;
  }
  return window.AppContext?.locale as string;
};

/**
 * Returns locale codes separated by a hyphen
 * @returns {string}
 * @example 'en-US'
 * @example 'fr-FR'
 */
export const getFormattedLocale = () => {
  const locale = getLocale();
  return locale.replace('_', '-');
};

export const isGlobalUser = () => {
  return !!window.AppContext?.globalAccountId;
};

export const getReportPermissions = () => window.AppContext?.reportPermissions as Record<string, unknown>;

export const getCountryCodeFromContext = (): string => {
  return window.AppContext?.countryCode as string;
};

export const getMarketplaceIdFromContext = (): string => {
  return window.AppContext?.marketplaceId as string;
};

export const isAdsFeedbackSystemEnabled = (): boolean => {
  return window.AppContext?.isAdsFeedbackSystemEnabled === 'true';
};

export const isAdsAssistantIngressEnabled = (): boolean => {
  return window.AppContext?.isAdsAssistantIngressEnabled === 'true';
};

export const isSaAdspDeprecationBannersEnabled = (): boolean => {
  return window.AppContext?.isSaAdspDeprecationBannersEnabled === 'true';
};

export const isSubscriptionMigrationEnabled = (): boolean => {
  return window.AppContext?.isSubscriptionMigrationEnabled === 'true';
};

export const isUiRossCutoverEnabled = (): boolean => {
  return window.AppContext?.isUiRossCutoverEnabled === 'true';
};

//TODO: Clean-up Benchmarks report weblab after 60 days post launch: https://sim.amazon.com/issues/RCMRX-12278
export const isBenchmarksReportEnabled = () => {
  return window.AppContext?.isScaledBenchmarksReportEnabled === 'true';
};

export const isRDDAdvertiser = () => {
  return window.AppContext?.isRDDAdvertiser === 'true';
};

export const getUserPreferencesFromContext = () => window.AppContext?.userPreferences as Record<string, unknown>;
